<template>
  <mobile-responsive-shell :title="title">
    <desktop-view />
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/stocks/designations/Edit.vue";

export default {
  name: "MobileStocksDesignationsEdit",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Modifier désignation",
    };
  },
};
</script>
